(function () {
  function normalize(text) {
    return (text || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getBcpoRoot() {
    return document.querySelector('#bcpo');
  }

  function unlockSoldOutColorSwatches() {
    const root = getBcpoRoot();
    if (!root) return;

    const soldOutParents = root.querySelectorAll(
      '.bcpo-images .bcpo-image-parent.bcpo-disabled, .bcpo-images .bcpo-image-parent.bcpo-really-disabled'
    );

    soldOutParents.forEach((parent) => {
      const input = parent.querySelector('input.bcpo-front-image-option');
      const label = parent.querySelector('label');

      if (!input) return;

      input.removeAttribute('disabled');
      input.disabled = false;
      input.setAttribute('data-jg-sold-out-clickable', 'true');

      parent.classList.remove('bcpo-really-disabled');
      parent.setAttribute('data-jg-sold-out', 'true');

      parent.style.pointerEvents = 'auto';
      if (label) {
        label.style.pointerEvents = 'auto';
        label.style.cursor = 'pointer';
      }
    });
  }

  // Fix: Notify Me (Hengam) sets a "Pre-Order Now" label/class on the submit button
  // when a preorder selling plan is applied, but doesn't reliably reset it when the
  // shopper switches to an in-stock variant without a page refresh. This checks the
  // actual form state (is a selling plan still active?) rather than relying on which
  // script last touched the button, so it self-heals regardless of ordering.
  function resetStalePreorderLabel(button) {
    const buttonText = button.querySelector('span');
    const isPreorderMarked =
      button.classList.contains('hengam-preorder-button') ||
      (buttonText && buttonText.textContent.trim() === 'Pre-Order Now');

    if (!isPreorderMarked) return;

    const form = button.closest('form') || document.querySelector('product-form');
    const hasActiveSellingPlan = Boolean(
      form?.querySelector('input[name="selling_plan"], input[name="properties[_purchase_type]"]')
    );

    if (hasActiveSellingPlan) return;

    button.classList.remove('hengam-preorder-button');
    button.removeAttribute('disabled');
    button.removeAttribute('aria-disabled');

    if (buttonText) {
      buttonText.textContent = window.variantStrings?.addToCart || 'Add to cart';
    }
  }

  function updateSoldOutPurchaseState() {
    const selectedSoldOutInput = document.querySelector(
      '#bcpo .bcpo-images input.bcpo-front-image-option[data-jg-sold-out-clickable="true"]:checked'
    );

    const isSoldOutSelection = Boolean(selectedSoldOutInput);

    const submitButtons = document.querySelectorAll(
      'product-form button[type="submit"][name="add"], button.product-form__submit'
    );

    submitButtons.forEach((button) => {
      const buttonText = button.querySelector('span');

      if (isSoldOutSelection) {
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('is-jg-sold-out');

        if (buttonText) {
          buttonText.textContent = 'Sold Out';
        }

        return;
      }

      if (button.classList.contains('is-jg-sold-out')) {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
        button.classList.remove('is-jg-sold-out');

        if (buttonText) {
          buttonText.textContent = window.variantStrings?.addToCart || 'Add to cart';
        }
      }

      resetStalePreorderLabel(button);
    });
  }

  function getSelectedEmbroidery() {
    const selected = document.querySelector(
      '#bcpo input[name="properties[Embroidery]"]:checked'
    );

    return normalize(selected ? selected.value : '');
  }

  function getSelectedProductColor() {
    const selected = document.querySelector(
      '#bcpo .bcpo-images input.bcpo-front-image-option:checked'
    );

    if (selected && selected.value) return normalize(selected.value);

    const visibleColorLabel = document.querySelector(
      '#bcpo .bcpo-images .bcpo-label .bcpo-value'
    );

    return normalize(visibleColorLabel ? visibleColorLabel.textContent : '');
  }

  function getEmbroideryColorGroups() {
    const root = getBcpoRoot();
    if (!root) return [];

    return Array.from(root.querySelectorAll('.selector-wrapper.bcpo-colors')).filter((group) => {
      const title = group.querySelector('.bcpo-title');
      return normalize(title ? title.textContent : '').includes('embroidery color');
    });
  }

  function setGroupVisible(group, visible) {
    const label = group.querySelector('.bcpo-label');
    const selector = group.querySelector('.single-option-selector');

    group.style.display = visible ? '' : 'none';

    if (label) label.style.display = visible ? '' : 'none';
    if (selector) selector.style.display = visible ? '' : 'none';

    group.querySelectorAll('input, select, textarea').forEach((field) => {
      if (visible) {
        field.removeAttribute('disabled');
        field.disabled = false;
      } else {
        field.checked = false;
        field.setAttribute('disabled', 'disabled');
        field.disabled = true;
      }
    });
  }

  function updateEmbroideryColorVisibility() {
    const embroidery = getSelectedEmbroidery();
    const selectedColor = getSelectedProductColor();
    const shouldShowColorOptions = embroidery === 'add custom embroidery';

    getEmbroideryColorGroups().forEach((group) => {
      const title = normalize(group.querySelector('.bcpo-title')?.textContent || '');
      const matchesCurrentColor =
        selectedColor && title.startsWith(selectedColor) && title.includes('embroidery color');

      setGroupVisible(group, shouldShowColorOptions && matchesCurrentColor);
    });
  }

  // Notify Me (Hengam) adds/removes its selling_plan / properties[_purchase_type] hidden
  // inputs on the real add-to-cart form asynchronously, with no DOM event we can reliably
  // hook (there is no "variant:change" CustomEvent dispatched anywhere in this theme).
  // Watching the form directly for that mutation is the trustworthy signal that Hengam's
  // preorder state has actually changed, so we re-check the button label at that exact moment.
  function observePreorderFormMutations() {
    const forms = document.querySelectorAll('product-form form[data-type="add-to-cart-form"]');

    forms.forEach((form) => {
      if (form.dataset.jgPreorderWatched === 'true') return;
      form.dataset.jgPreorderWatched = 'true';

      const observer = new MutationObserver(() => {
        scheduleRun();
      });

      observer.observe(form, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
    });
  }

  function runJollyProductOptionFixes() {
    unlockSoldOutColorSwatches();
    updateEmbroideryColorVisibility();
    updateSoldOutPurchaseState();
    observePreorderFormMutations();
    }

    let scheduled = false;

    function scheduleRun() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(() => {
        runJollyProductOptionFixes();
        scheduled = false;
    });
    }

  document.addEventListener('DOMContentLoaded', scheduleRun);
  window.addEventListener('load', scheduleRun);
  document.addEventListener('click', scheduleRun);
  document.addEventListener('change', scheduleRun);
})();